import { Box, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SOIL_CATEGORY_VALUES } from '../../../api/resources/soilClassification.constants';
import { SoilConditionDTO } from '../../../api/generated';

interface SoilConditionInputProps {
  condition: SoilConditionDTO;
  onChange: (condition: SoilConditionDTO) => void;
}

export default function SoilConditionInput({ condition, onChange }: SoilConditionInputProps) {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', gap: '1em' }}>
      <FormControl size='small' sx={{ width: '15em' }}>
        <InputLabel>{t('billableMaterial.category')}</InputLabel>
        <Select
          value={condition.category}
          label={t('billableMaterial.category')}
          onChange={(e) => {
            const newCategory = e.target.value;
            const defaultValue = SOIL_CATEGORY_VALUES[newCategory]?.[0] || '';
            onChange({ ...condition, category: newCategory, value: defaultValue });
          }}
        >
          {Object.keys(SOIL_CATEGORY_VALUES).map((cat) => (
            <MenuItem key={cat} value={cat}>
              {t(`attributes.soilClassification.categories.${cat}.label`, cat.replace(/_/g, ' '))}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size='small' sx={{ minWidth: '10em' }}>
        <InputLabel>{t('billableMaterial.value')}</InputLabel>
        <Select
          value={condition.value}
          label={t('billableMaterial.value')}
          onChange={(e) => onChange({ ...condition, value: e.target.value })}
          disabled={!condition.category}
        >
          {condition.category &&
            SOIL_CATEGORY_VALUES[condition.category]?.map((val) => (
              <MenuItem key={val} value={val}>
                {t(`attributes.soilClassification.categories.${condition.category}.values.${val}`, val)}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
}
